import React, { Component } from 'react'
import styled from 'styled-components'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { getCurrentLanguage, setLanguage } from 'utils/language'

const languages = [
  {
    image: '/img/flags/vi.png',
    value: 'vi',
    name: 'Tiếng Việt'
  },
  {
    image: '/img/flags/en.png',
    value: 'en',
    name: 'English'
  }
]

const CustomDropdownToggle = styled(DropdownToggle)`
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-left: 16px;
  border-radius: 8px;
  img {
    margin-right: 8px;
  }
  &:after {
    margin-left: 8px !important;
    vertical-align: middle !important;
    border-right: 5px solid transparent !important;
    border-bottom: 5px solid !important;
    border-left: 5px solid transparent !important;
  }
`

const CustomDropdownItem = styled(DropdownItem)`
  display: flex;
  align-items: center;
  img {
    margin-right: 8px;
  }
`

const Image = styled.img`
  height: 24px;
  position: relative;
`

class ChangeLanguage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dropdownOpen: false
    }
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  getCurrentLanguage = () => {
    const current = getCurrentLanguage()
    return languages.find(c => current.indexOf(c.value) > -1)
  }

  render () {
    const currentLanguage = this.getCurrentLanguage()
    return (
      <UncontrolledDropdown direction='up'>
        <CustomDropdownToggle caret color='light'>
          <Image src={currentLanguage.image} /> <span>{currentLanguage.name}</span>
        </CustomDropdownToggle>
        <DropdownMenu>
          {languages.map(language => (
            <CustomDropdownItem
              key={language.value}
              onClick={() => setLanguage(language.value)}
            >
              <Image src={language.image} /> {language.name}
            </CustomDropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  }
}

export default ChangeLanguage
